import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import { HUMANIZE_PROVIDER } from "constants/vcs_providers";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";
import { VcsIntegrationDetails, VcsProvider } from "types/generated";

import {
  BUILT_IN_GITHUB_INTEGRATION_DESCRIPTION,
  BUILT_IN_GITHUB_INTEGRATION_NAME,
} from "../../shared/VcsList/constants";
import { getIntegrationDetails } from "../../shared/VcsShared/components/Details/helpers";
import VCSProviderIcon from "../../shared/VcsShared/components/ProviderIcon";

type VCSIntegrationsBuiltInGitHubDetailsDrawerProps = {
  details: VcsIntegrationDetails | undefined;
  onClose?: () => void;
};

const VCSIntegrationsBuiltInGitHubDetailsDrawer = createDrawer(
  ({ details, onClose }: VCSIntegrationsBuiltInGitHubDetailsDrawerProps) => {
    return (
      <DrawerSimple onClose={onClose}>
        {details && (
          <>
            <DrawerHeader justify="between">
              <DrawerHeaderTitle title="Source code details" />
              <DrawerCloseIcon />
            </DrawerHeader>

            <DrawerBody>
              <FormField label="Provider">
                <Box gap="medium">
                  <VCSProviderIcon provider={VcsProvider.Github} />

                  <Typography tag="span" variant="p-body2">
                    {HUMANIZE_PROVIDER[VcsProvider.Github]}
                  </Typography>
                </Box>
              </FormField>

              <FormFieldViewText
                label="Integration name"
                value={BUILT_IN_GITHUB_INTEGRATION_NAME}
              />

              {getIntegrationDetails(details)}

              <DescriptionDetails description={BUILT_IN_GITHUB_INTEGRATION_DESCRIPTION} />
            </DrawerBody>
          </>
        )}
      </DrawerSimple>
    );
  }
);

export const showVCSIntegrationsBuiltInGitHubDetailsDrawer = createDrawerTrigger(
  VCSIntegrationsBuiltInGitHubDetailsDrawer
);
